import { addQueryArgs, getQueryArgs } from "@wordpress/url";

export interface OauthData {
	accessToken: string;
	expiresIn: number;
	expiresAt: Date | null;
	tokenType: string;
	siteId: number;
	scope: string;
}

export const initialOauthState = {
	accessToken: '',
	expiresIn: 0,
	expiresAt: null,
	tokenType: '',
	siteId: 0,
	scope: '',
};

export function readOauthData(): OauthData {
	// @ts-expect-error The variable is injected by webpack.DefinePlugin.
	const storedOAuthData = localStorage.getItem( HPP_OAUTH2_KEY );
	if ( storedOAuthData ) {
		return JSON.parse( storedOAuthData );
	}

	return initialOauthState;
}

export function getToken() {
	return readOauthData().accessToken;
}

export function setOauthData( oauthData: OauthData ) {
	// @ts-expect-error The variable is injected by webpack.DefinePlugin.
	localStorage.setItem( HPP_OAUTH2_KEY, JSON.stringify( oauthData ));
}

export function clearOauthData() {
	// @ts-expect-error The variable is injected by webpack.DefinePlugin.
	localStorage.removeItem( HPP_OAUTH2_KEY );
}

export function getRedirectURL(): string {
	const redirect = getQueryArgs( window.location.search )?.return?.toString() || '';
	const redirectParams = new URLSearchParams( {
		response_type: 'token',
		// @ts-expect-error The variable is injected by webpack.DefinePlugin.
		client_id: HPP_OAUTH2_CLIENT_ID,
		redirect_uri: addQueryArgs( window.location.href, { return: redirect } ),
		scope: 'global',
	} );

	// @ts-expect-error The variable is injected by webpack.DefinePlugin.
	return addQueryArgs( HPP_OAUTH2_AUTHORIZE_URL, redirectParams );
};
